export default {
    CHART1_DRAWN: 'CHART1_DRAWN',
    CHART2_DRAWN: 'CHART2_DRAWN',
    BIRTH_CHART1_DRAWN: 'BIRTH_CHART1_DRAWN',
    BIRTH_CHART2_DRAWN: 'BIRTH_CHART2_DRAWN',
    BIRTH_CHART_DRAWN_BOTH: 'BIRTH_CHART_DRAWN_BOTH',
    CHART_DRAWN_BOTH: 'CHART_DRAWN_BOTH',
    CHART1_FETCHED: 'CHART1_FETCHED',
    CHART2_FETCHED: 'CHART2_FETCHED',
    HOME_LOADING: 'HOME_LOADING',
    HOME_PRINT_LOADING: 'HOME_PRINT_LOADING',
    CHART_TO_PRINT: 'CHART_TO_PRINT'
};